//---------------------------------
//-------------ENUMS---------------
//---------------------------------

export enum Language {
  EN = 'en',
  PT = 'pt',
}

export enum IconType {
  DEFAULT = '',
  OUTLINE = '-outline',
}

export enum IconColor {
  GRAY = 'gray',
  BLACK = 'black',
  WHITE = 'white',
  COLOR = 'color',
}

export enum Platform {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

//---------------------------------
//------------TYPES----------------
//---------------------------------

export type ItemElement = {
  name: string;
  icon?: string;
  link?: string;
  img?: string;
  desc?: string;
};

export type ImageElement = ItemElement & {
  width?: number;
  height?: number;
};

export type PlatformItem = ItemElement & {
  name: Platform;
};

export type SiteHeaderProps = {
  show?: boolean;
  animated?: boolean;
  logoHref?: string;
  theme?: 'default' | 'detail';
};
